import * as React from 'react';

import * as styles from './CallButton.css';
import { DynamicCalltrackingButton } from '../DynamicCalltrackingButton';

interface ICallButtonProps {
  announcementId: number;
  handleShowPhoneClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent> | MouseEvent): void;
  isPhonesVisible: boolean;
  phone: string;
  siteBlockId: number | null;
}

const PLACE_TYPE = 'gallery_innactive_card';

export const CallButton = ({
  announcementId,
  handleShowPhoneClick,
  isPhonesVisible,
  phone,
  siteBlockId,
}: ICallButtonProps) => {
  return (
    <DynamicCalltrackingButton
      openPhoneClassName={styles['phone']}
      buttonText="Контакты застройщика"
      buttonFullWidth={true}
      isOpen={isPhonesVisible}
      announcementId={announcementId}
      onClick={handleShowPhoneClick}
      phone={phone}
      placeType={PLACE_TYPE}
      blockId={siteBlockId}
    />
  );
};
